module.exports = __webpack_public_path__ + "img/MQTEK.6536a62b.jpg";